/**
 * Same-page jump links (`<a href="#section">`). After the server-rendering
 * upgrade the router reacts to the hash change and restores scroll to the
 * top, so the browser's native jump never lands. This intercepts those
 * clicks and scrolls to the target itself, keeping the hash in the address
 * bar without triggering a router navigation.
 */
export function handleInPageAnchorClick(event: MouseEvent): void {
  if (event.defaultPrevented || event.button !== 0) return;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const target = event.target as Element | null;
  const anchor = target?.closest?.("a[href^='#']") as HTMLAnchorElement | null;
  if (!anchor) return;
  const id = decodeURIComponent(anchor.getAttribute("href")!.slice(1));
  if (!id) return;
  const section = document.getElementById(id);
  if (!section) return;
  event.preventDefault();
  const reduce = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
  section.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
  if (!section.hasAttribute("tabindex") && !/^(A|BUTTON|INPUT|SELECT|TEXTAREA)$/.test(section.tagName)) {
    section.setAttribute("tabindex", "-1");
  }
  section.focus({ preventScroll: true });
  window.history.replaceState(window.history.state, "", `#${id}`);
}
